<template>
    <div id="contenedor-eliminar-infraestructura">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar infraestructura </v-card-title>
        <v-card-text>
          <span class="secondary--text"> ¿Desea eliminar la infraestructura? </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarInfraestructura"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixInfraestructura from './mixInfraestructura';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarInfraestructura',
  mixins: [mixInfraestructura],
  props: {
    infraestructuraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style lang="scss" scoped>
  </style>
